import App from './App';
import envValues from './enviornment';
import { getCookies, setCookies } from './hooks/useCookies';
import { SERVER_BASE_URL } from './redux/apiConstants';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom/client';

// --- REQUEST INTERCEPTOR ---
axios.interceptors.request.use(
  (config) => {
    // attach token if present
    const token = getCookies('Token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// --- RESPONSE INTERCEPTOR ---
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalConfig = error.config;

    // Handle 401 - try refresh
    if (
      error.response?.status === 401 &&
      error.response?.data?.message === 'Please authenticate' &&
      getCookies('refreshToken')
    ) {
      try {
        const rs = await axios.post(`${SERVER_BASE_URL}/auth/refresh-tokens`, {
          refreshToken: getCookies('refreshToken'),
        });

        setCookies('Token', rs.data.data.access.token);
        setCookies('refreshToken', rs.data.data.refresh.token);

        // retry with new token
        originalConfig.headers.Authorization = `Bearer ${rs.data.data.access.token}`;
        return axios(originalConfig);
      } catch (refreshError) {
        // refresh also failed → redirect to login
        window.location.assign(envValues.REACT_APP_LOGIN_URL);
        return Promise.reject(refreshError);
      }
    }

    // Handle 403
    if (error.response?.status === 403) {
      window.location.assign(envValues.REACT_APP_API_PERMISSION_DENIED);
    }

    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
